import React, { useEffect, useState } from "react";
import ConstructionImg from "../../assets/images/under-construction.jpg";
import "./maintenance.scss";

export default function Maintenance() {
  const targetDate = new Date(process.env.REACT_APP_MAINTENANCE_END || new Date());

  const formatTime = (value) => (value < 10 ? `0${value}` : value);

  const calculateTimeLeft = () => {
    const difference = targetDate.getTime() - new Date().getTime();
    if (difference <= 0) {
      return { days: "00", hours: "00", minutes: "00", seconds: "00" };
    }
    return {
      days: formatTime(Math.floor(difference / (1000 * 60 * 60 * 24))),
      hours: formatTime(Math.floor((difference / (1000 * 60 * 60)) % 24)),
      minutes: formatTime(Math.floor((difference / (1000 * 60)) % 60)),
      seconds: formatTime(Math.floor((difference / 1000) % 60)),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <article className="countdown-container">
      <figure className="image-container">
        <img src={ConstructionImg} alt="Workers setting up REAPS" />
      </figure>
      <div className="content">
        <h1 className="title">REAPS is Updating</h1>
        <p className="description">
          We are currently deploying the latest version of REAPS to enhance your experience.
          During this process, the site will be temporarily unavailable.
          We will be back in:
        </p>

        <div className="countdown">
          <div className="time-box">
            <span className="time">{timeLeft.days}</span>
            <span className="label">Days</span>
          </div>
          <span className="separator">:</span>
          <div className="time-box">
            <span className="time">{timeLeft.hours}</span>
            <span className="label">Hours</span>
          </div>
          <span className="separator">:</span>
          <div className="time-box">
            <span className="time">{timeLeft.minutes}</span>
            <span className="label">Minutes</span>
          </div>
          <span className="separator">:</span>
          <div className="time-box">
            <span className="time">{timeLeft.seconds}</span>
            <span className="label">Seconds</span>
          </div>
        </div>

        <p className="contact-info">
          For urgent inquiries, please contact support at
          <a href="mailto:reaps@viableknowledgemasters.com"> reaps@viableknowledgemasters.com</a>
        </p>
      </div>
    </article>
  );
}
